import React from 'react';

export default function PrivacyPolicy() {
  return (
    <div className="max-w-4xl mx-auto px-4 py-8 text-justify text-gray-800">
      <h1 className="text-2xl font-bold mb-6 text-green-700">Política de Privacidade</h1>

      <p><strong>Programa de Conformidade – Privacidade e Proteção de Dados Pessoais respaldada na Lei nº 13.709, de 14 de agosto de 2018</strong></p>

      <h2 className="text-xl font-semibold mt-6 mb-2">AVISO DE PRIVACIDADE</h2>
      <p>
        A CPW DIGITAL AUTOMOTIVA LTDA. (YOUCONNECT), deseja manter uma relação de confiança e transparência junto aos seus clientes e visitantes.
        Então, para te ajudar a entender quais as informações coletadas, porque as coletamos, se elas são compartilhadas e com quem são compartilhadas, elaboramos este documento.
        Outro objetivo é informá-lo(a) sobre seus direitos relativos a esses dados coletados e como poderá exercê-los junto a nossa empresa.
        Temos como prioridade zelar pela privacidade e segurança dos seus Dados Pessoais.
      </p>

      <h3 className="font-semibold mt-4">1. QUAIS DADOS PESSOAIS COLETAMOS?</h3>
      <p>
        Os dados descritos a seguir compõem todas as informações coletadas e/ou obtidas sobre você:
        <br/>- Dados de identificação: nome e sobrenome, CPF, data de nascimento e filiação;
        <br/>- Dados de contato: telefone e e-mail pessoal e/ou corporativo, para contato; endereço pessoal e/ou profissional.
      </p>

      <h3 className="font-semibold mt-4">2. COMO COLETAMOS ESSES DADOS PESSOAIS?</h3>
      <p>
        Os dados pessoais que possuímos sobre você podem ter sido informados diretamente por você, por terceiros ou coletados em bases públicas.
        <br/><strong>Informações fornecidas diretamente por você:</strong> durante o seu relacionamento conosco, nós pedimos algumas informações diretamente para você.
        <br/><strong>Informações obtidas de terceiros:</strong> como dados disponíveis em redes de networking como LinkedIn.
      </p>

      <h3 className="font-semibold mt-4">3. COMO UTILIZAMOS AS SUAS INFORMAÇÕES?</h3>
      <p>
        - Para a finalidade que o dado foi fornecido (ex: execução do serviço contratado);
        <br/>- Para cumprir com obrigações legais e regulatórias;
        <br/>- Para exercer direitos legais, inclusive em processos;
        <br/>- Para realizar atividades internas com base em interesse legítimo;
        <br/>- Para executar contratos ou diligências pré-contratuais.
      </p>

      <h3 className="font-semibold mt-4">4. O QUE SÃO E COMO UTILIZAMOS OS COOKIES?</h3>
      <p>
        Cookies armazenam informações como nome e e-mail para tornar sua experiência melhor. Utilizamos:
        <br/>- Cookies necessários para funcionalidade do site;
        <br/>- Cookies para melhorar serviços e personalizar publicidade e conteúdo.
      </p>

      <h3 className="font-semibold mt-4">5. POR QUANTO TEMPO ARMAZENAMOS OS SEUS DADOS?</h3>
      <p>
        Os dados serão mantidos apenas pelo tempo necessário ou exigido por lei. Você pode solicitar a eliminação, exceto em casos legais.
      </p>

      <h3 className="font-semibold mt-4">6. COM QUEM COMPARTILHAMOS OS SEUS DADOS?</h3>
      <p>
        Podemos compartilhar com terceiros (ex: bancos) para operacionalizar serviços. A lista de parceiros pode ser solicitada via e-mail.
      </p>

      <h3 className="font-semibold mt-4">7. COMO MANTEMOS OS SEUS DADOS PESSOAIS SEGUROS?</h3>
      <p>
        - Proteção contra acesso não autorizado;
        <br/>- Acesso restrito e essencial por equipe autorizada;
        <br/>- Obrigações legais aos colaboradores quanto ao tratamento seguro dos dados.
      </p>

      <h3 className="font-semibold mt-4">8. QUAIS SÃO OS SEUS DIREITOS?</h3>
      <p>
        Você pode:
        <br/>- Saber se e quais dados são tratados;
        <br/>- Corrigir, atualizar ou completar dados;
        <br/>- Solicitar anonimização, bloqueio ou exclusão de dados desnecessários;
        <br/>- Solicitar portabilidade ou exclusão total dos dados;
        <br/>- Revogar consentimento a qualquer momento.
        <br/><br/>
        Para isso, entre em contato via e-mail com nosso Encarregado de Dados.
      </p>

      <h3 className="font-semibold mt-4">9. ALTERAÇÕES NESTE AVISO</h3>
      <p>
        Este aviso pode ser alterado a qualquer momento. Última versão publicada em nosso site em novembro de 2024.
      </p>
    </div>
  );
}
